import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ContactForm } from '@metlas/contact';
import './Realtor.css';

const PILLARS = [
  {
    headline: 'Automated Lead Qualification',
    copy: 'Stop chasing cold leads. Our AI acts as your 24/7 digital concierge, engaging prospective buyers in natural conversations to vet budget and intent so you only focus on ready-to-buy clients.',
  },
  {
    headline: 'Full-Cycle Transaction AI',
    copy: 'Master the chaos from lead-to-close. Metlas tracks every task after the initial seller contact, managing agreements and listing milestones. Plus, generate and interactively refine premium marketing materials in minutes.',
  },
  {
    headline: 'Precision Property Matching',
    copy: 'Connect buyers to listings using cutting-edge neural matching. Deliver hyper-personalized notifications that bypass spam filters and feel like a curated white-glove service.',
  },
];

const Realtor: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="realtor-page">
      <div className="realtor-bg">
        <div className="realtor-mesh" />
        <div className="realtor-nebula realtor-nebula-1" />
        <div className="realtor-nebula realtor-nebula-2" />
        <div className="realtor-nebula realtor-nebula-3" />
      </div>

      <div className={`realtor-content ${isVisible ? 'visible' : ''}`}>
        <nav className="realtor-nav">
          <Link to="/" className="realtor-back">
            ← Back to Metlas
          </Link>
        </nav>

        <header className="realtor-hero">
          <h1 className="realtor-headline">An AI-native solution for realtors.</h1>
        </header>

        <section className="realtor-pillars">
          {PILLARS.map((pillar, i) => (
            <article key={i} className="realtor-pillar">
              <h2 className="realtor-pillar-headline">{pillar.headline}</h2>
              <p className="realtor-pillar-copy">{pillar.copy}</p>
            </article>
          ))}
        </section>
      </div>

      <aside className="realtor-contact-float">
        <ContactForm variant="float" />
      </aside>
    </div>
  );
};

export default Realtor;
